import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NotificationToFrontDataModel} from '../../models/messaging/noteToFront/notification-to-front-data.model';
import {NotificationToFrontAppointmentDataModel} from '../../models/messaging/noteToFront/notification-to-front-appointment-data.model';
import {NotificationNeededDataModel} from '../../models/messaging/noteToFront/notification-needed-data.model';
import {NotificationNeededItemDataModel} from '../../models/messaging/noteToFront/notification-needed-item-data.model';
import {NotificationToFrontNeededItemContactModel} from '../../dialog/notifications/notification-to-front-create-dialog/dialog/models/notification-to-front-needed-item-contact.model';
import {ContactDataModel} from '../../models/person/contact-data.model';
import { NoteToFrontInformation } from 'src/app/models/messaging/noteToFront/note-to-front-information.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationToFrontService {

  constructor(private http: HttpClient) {

  }

  changePatientStatusFlags(patientId: string, softBall: boolean, hardBall: boolean, dneta: boolean){
    const notificationFlags = { 
      isHardBall: hardBall,
      isSoftBall: softBall,
      isDoNotEverTreatAgain: dneta

    };
    return this.http.post(`api/patients/${patientId}/flags`, notificationFlags);

  }

  getNotificationsInfo(currentPatientId: string, currentPatientCaseId: string) {
    return this.http.get<NoteToFrontInformation>(`api/notifications/front/${currentPatientId}/${currentPatientCaseId}`);
  }
  getNotifications(currentPatientId: string, currentPatientCaseId: string) {
    return this.http.get<NotificationToFrontDataModel[]>(`api/notification-front/get-notifications/${currentPatientId}/${currentPatientCaseId}`);
  }

  saveNotification(notification: NotificationToFrontDataModel) {
    return this.http.post<NotificationToFrontDataModel>('api/notification-front/save-notification', notification);
  }

  saveAppointment(appointment: NotificationToFrontAppointmentDataModel) {
    return this.http.post<NotificationToFrontAppointmentDataModel>('api/notification-front/save-appointment', appointment);
  }

  getCaseTeethCount(caseId: string) {
    return this.http.get<number>(`api/notification-front/get-case-teeth/${caseId}`);
  }

  deleteOperatory(operatoryId: string) {
    return this.http.get<void>(`api/notification-front/delete-op/${operatoryId}`);
  }

  getItemsNeeded(patientId: string, caseWorkItemId: string) {
    return this.http.get<NotificationNeededDataModel>(`api/notification-front/get-items-needed/${patientId}/${caseWorkItemId}`);
  }

  saveNeeded(notificationNeededModel: NotificationNeededDataModel) {
    return this.http.post('api/notification-front/save-needed-items', notificationNeededModel);
  }

  deleteNeededItem(model: NotificationNeededItemDataModel) {
    return this.http.get(`api/notification-front/delete-needed-item/${model.dataNotificationNeededItemID}`);
  }

  getPersistentContactData(persist: NotificationToFrontNeededItemContactModel[]) {
    return this.http.post<ContactDataModel[]>(`api/notification-front/get-persistent-contacts`, persist);
  }

  markToBeCompleted(notification: NotificationToFrontDataModel) {
    return this.http.get(`api/notification-front/mark-to-be-completed/${notification.NotificationFrontID}`);
  }

  deleteNotification(notification: NotificationToFrontDataModel) {
    return this.http.post(`api/notification-front/delete-notification`, notification);
  }

  deleteNoteAppointment(appointment: NotificationToFrontAppointmentDataModel) {
    return this.http.post(`api/notification-front/delete-appointment`, appointment);
  }
}
